import { GridView as GridViewIcon, ViewSidebar as ViewSidebarIcon } from '@mui/icons-material';
import { ButtonBase, Tooltip } from '@mui/material';

import type { ManualLayoutChoice } from '../types';

interface LayoutToggleProps {
  layout: ManualLayoutChoice;
  onChange: (choice: ManualLayoutChoice) => void;
}

export function LayoutToggle({ layout, onChange }: LayoutToggleProps) {
  const handleClick = () => {
    onChange(layout === 'speaker' ? 'grid' : 'speaker');
  };

  // Show the icon for the layout you'd switch TO
  const isSpeaker = layout === 'speaker';

  return (
    <Tooltip title={isSpeaker ? 'Grid view' : 'Speaker view'}>
      <ButtonBase
        onClick={handleClick}
        aria-label={isSpeaker ? 'Switch to grid view' : 'Switch to speaker view'}
        sx={{
          width: 48,
          height: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 1,
          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
        }}
      >
        {isSpeaker ? (
          <GridViewIcon sx={{ fontSize: 20, color: 'common.white' }} />
        ) : (
          <ViewSidebarIcon sx={{ fontSize: 20, color: 'common.white' }} />
        )}
      </ButtonBase>
    </Tooltip>
  );
}
